import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';
import { isApiError } from '@nucleus-commerce/api-client/transport';
import { toast } from '@nucleus-commerce/ui/components/sonner';

import { recoveryErrorKey } from '../schemas/checkout-rules';

import { useSendRecovery } from './use-send-recovery';

/** Sends the recovery email; a refusal toasts why in plain words, with the request id. */
export function useSendRecoveryAction(storeId: string) {
  const { t } = useTranslation(['abandonedCheckouts', 'errors']);
  const message = useErrorMessage();
  const send = useSendRecovery(storeId);
  const { mutate } = send;
  const onSend = useCallback(
    (id: string) =>
      mutate(id, {
        onError: (error) => {
          const key = recoveryErrorKey(error);
          const requestId = isApiError(error) ? error.requestId : undefined;
          toast.error(key ? t(key) : message(error), {
            description: requestId ? t('errors:requestIdShort', { requestId }) : undefined,
          });
        },
      }),
    [message, mutate, t],
  );
  return { onSend, sendingId: send.isPending ? send.variables : null };
}
